import React, { FC } from "react";
import { useProfileBanner } from "../../hooks/profile/useProfileBanner";
import { useProfilePic } from "../../hooks/profile/useProfilePic";

interface BannerProps {
  userId: string;
}

const Banner: FC<BannerProps> = ({ userId }) => {
  const banner = useProfileBanner(userId);

  return (
    <div className="w-full relative aspect-w-5 aspect-h-7/4 md:aspect-h-1">
      {banner ? (
        <img className="absolute w-full h-full object-cover" src={banner} />
      ) : (
        <div className="absolute w-full h-full horiz-gradient"></div>
      )}
    </div>
  );
};

export default Banner;
